<template>


  <v-footer class="footerBar">
   <div><strong>Atelier 2</strong> Geoquizz - Cisiie.</div>
   <div>Yann Dumas - Nicolas Bobelet - Mohamed Alhasne - Daniel Ricklin - Alexandra Martin</div>
 </v-footer>

</template>


<script>
export default {
	name: 'footerBar',
	data () {
    return {
    }
	}
}
</script>

<style scoped>
  .footerBar{
    padding : 30px 0px;
    position:relative;
    bottom : 0px;
    width:100%;
  }
  .footerBar div{
    margin:auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue